import { render } from "./VehiclesComponent.vue?vue&type=template&id=5e7bd494&scoped=true"
import script from "./VehiclesComponent.vue?vue&type=script&lang=js"
export * from "./VehiclesComponent.vue?vue&type=script&lang=js"

import "./VehiclesComponent.vue?vue&type=style&index=0&id=5e7bd494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7bd494"]])

export default __exports__